import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface RetailerDiscountThresholdExceededProps extends BaseTemplateProps {
  productCount: number
}

export const RetailerDiscountThresholdExceeded: TemplateDefinition<RetailerDiscountThresholdExceededProps> =
  {
    renderParams: (props: RetailerDiscountThresholdExceededProps) => ({
      messageKey: 'notificationsDomain.templates.retailerDiscountThresholdExceeded',
      values: {
        productCount: props.productCount,
      },
    }),
  }
